import * as z from "@rocicorp/zero"

export const account = z
  .table("account")
  .columns({
    activated_at: z.number().optional(),
    avatar_url: z.string(),
    bio: z.string().optional(),
    gh_id: z.number(),
    id: z.string(),
    inserted_at: z.number(),
    last_seen_at: z.number().optional(),
    login: z.string(),
    name: z.string().optional(),
    role: z.enumeration<"crew" | "user">(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const account_redirect = z
  .table("account_redirect")
  .columns({
    account_id: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    login: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const attachment = z
  .table("attachment")
  .columns({
    id: z.string(),
    inserted_at: z.number(),
    message_id: z.string(),
    name: z.string(),
    size: z.number(),
    type: z.string<
      | "image/png"
      | "image/jpeg"
      | "image/jpg"
      | "image/gif"
      | "image/webp"
      | "image/svg+xml"
      | "video/mp4"
      | "video/quicktime"
      | "video/webm"
      | "application/pdf"
    >(),
    updated_at: z.number(),
    key: z.string(),
    width: z.number().optional(),
    height: z.number().optional(),
    blurhash: z.string().optional(),
  })
  .primaryKey("id")

export const channel = z
  .table("channel")
  .columns({
    id: z.string(),
    inserted_at: z.number(),
    name: z.string(),
    repository_id: z.string(),
    updated_at: z.number(),
    private: z.boolean(),
  })
  .primaryKey("id")

export const channel_member = z
  .table("channel_member")
  .columns({
    account_id: z.string(),
    channel_id: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const channel_permission = z
  .table("channel_permission")
  .columns({
    channel_id: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    permission_id: z.string<"channel.send_message" | "channel.view">(),
    scope: z.enumeration<
      "channel" | "everyone" | "organization" | "repository"
    >(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const channel_subscription = z
  .table("channel_subscription")
  .columns({
    account_id: z.string(),
    channel_id: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    last_read_at: z.number(),
    subscribed_at: z.number().optional(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const installation = z
  .table("installation")
  .columns({
    account_id: z.string().optional(),
    deleted_at: z.number().optional(),
    gh_id: z.number(),
    id: z.string(),
    inserted_at: z.number(),
    organization_id: z.string().optional(),
    repository_selection: z.enumeration<"all" | "selected">(),
    suspended_at: z.number().optional(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const installation_repository = z
  .table("installation_repository")
  .columns({
    id: z.string(),
    inserted_at: z.number(),
    installation_id: z.string(),
    repository_id: z.string(),
    suspended_at: z.number().optional(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const issue = z
  .table("issue")
  .columns({
    account_id: z.string(),
    active_lock_reason: z
      .enumeration<"off-topic" | "resolved" | "spam" | "too heated">()
      .optional(),
    body: z.string().optional(),
    created_at: z.number(),
    closed_at: z.number().optional(),
    gh_id: z.number(),
    id: z.string(),
    inserted_at: z.number(),
    locked: z.boolean(),
    number: z.number(),
    repository_id: z.string(),
    state: z.enumeration<"closed" | "open">(),
    state_reason: z
      .enumeration<"completed" | "duplicate" | "not_planned" | "reopened">()
      .optional(),
    title: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const message = z
  .table("message")
  .columns({
    account_id: z.string(),
    channel_id: z.string(),
    content: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    thread_id: z.string().optional(),
    updated_at: z.number(),
    deleted_at: z.number().optional(),
  })
  .primaryKey("id")

export const organization = z
  .table("organization")
  .columns({
    avatar_url: z.string(),
    description: z.string().optional(),
    gh_id: z.number(),
    id: z.string(),
    inserted_at: z.number(),
    login: z.string(),
    name: z.string().optional(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const organization_member = z
  .table("organization_member")
  .columns({
    account_id: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    organization_id: z.string(),
    role: z.enumeration<"admin" | "member">(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const organization_redirect = z
  .table("organization_redirect")
  .columns({
    id: z.string(),
    inserted_at: z.number(),
    login: z.string(),
    organization_id: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const permission = z
  .table("permission")
  .columns({
    id: z.string<"channel.send_message" | "channel.view">(),
    inserted_at: z.number(),
    name: z.string(),
    description: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const pull_request = z
  .table("pull_request")
  .columns({
    account_id: z.string(),
    active_lock_reason: z
      .enumeration<"off-topic" | "resolved" | "spam" | "too heated">()
      .optional(),
    body: z.string().optional(),
    closed_at: z.number().optional(),
    created_at: z.number(),
    draft: z.boolean(),
    gh_id: z.number(),
    id: z.string(),
    inserted_at: z.number(),
    locked: z.boolean(),
    merged_at: z.number().optional(),
    number: z.number(),
    repository_id: z.string(),
    state: z.enumeration<"closed" | "open">(),
    title: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const reaction = z
  .table("reaction")
  .columns({
    account_id: z.string(),
    emoji: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    message_id: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const repository = z
  .table("repository")
  .columns({
    account_id: z.string().optional(),
    archived: z.boolean(),
    description: z.string().optional(),
    gh_id: z.number(),
    id: z.string(),
    inserted_at: z.number(),
    name: z.string(),
    organization_id: z.string().optional(),
    private: z.boolean(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const repository_member = z
  .table("repository_member")
  .columns({
    account_id: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    repository_id: z.string(),
    role: z.enumeration<"admin" | "maintain" | "read" | "triage" | "write">(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const repository_redirect = z
  .table("repository_redirect")
  .columns({
    id: z.string(),
    inserted_at: z.number(),
    name: z.string(),
    owner: z.string(),
    repository_id: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const thread = z
  .table("thread")
  .columns({
    id: z.string(),
    inserted_at: z.number(),
    message_count: z.number(),
    updated_at: z.number(),
    account_count: z.number(),
    last_message_at: z.number().optional(),
    message_id: z.string(),
  })
  .primaryKey("id")

export const thread_subscription = z
  .table("thread_subscription")
  .columns({
    account_id: z.string(),
    id: z.string(),
    inserted_at: z.number(),
    last_read_at: z.number(),
    subscribed_at: z.number().optional(),
    thread_id: z.string(),
    updated_at: z.number(),
  })
  .primaryKey("id")

export const tables = [
  account,
  account_redirect,
  attachment,
  channel,
  channel_member,
  channel_permission,
  channel_subscription,
  installation,
  installation_repository,
  issue,
  message,
  organization,
  organization_member,
  organization_redirect,
  permission,
  pull_request,
  reaction,
  repository,
  repository_member,
  repository_redirect,
  thread,
  thread_subscription,
]

export declare namespace Row {
  type account = z.Row<(typeof schema)["tables"]["account"]>
  type account_redirect = z.Row<(typeof schema)["tables"]["account_redirect"]>
  type attachment = z.Row<(typeof schema)["tables"]["attachment"]>
  type channel = z.Row<(typeof schema)["tables"]["channel"]>
  type channel_member = z.Row<(typeof schema)["tables"]["channel_member"]>
  type channel_permission = z.Row<
    (typeof schema)["tables"]["channel_permission"]
  >
  type channel_subscription = z.Row<
    (typeof schema)["tables"]["channel_subscription"]
  >
  type installation = z.Row<(typeof schema)["tables"]["installation"]>
  type installation_repository = z.Row<
    (typeof schema)["tables"]["installation_repository"]
  >
  type issue = z.Row<(typeof schema)["tables"]["issue"]>
  type message = z.Row<(typeof schema)["tables"]["message"]>
  type organization = z.Row<(typeof schema)["tables"]["organization"]>
  type organization_member = z.Row<
    (typeof schema)["tables"]["organization_member"]
  >
  type organization_redirect = z.Row<
    (typeof schema)["tables"]["organization_redirect"]
  >
  type permission = z.Row<(typeof schema)["tables"]["permission"]>
  type pull_request = z.Row<(typeof schema)["tables"]["pull_request"]>
  type reaction = z.Row<(typeof schema)["tables"]["reaction"]>
  type repository = z.Row<(typeof schema)["tables"]["repository"]>
  type repository_member = z.Row<(typeof schema)["tables"]["repository_member"]>
  type repository_redirect = z.Row<
    (typeof schema)["tables"]["repository_redirect"]
  >
  type thread = z.Row<(typeof schema)["tables"]["thread"]>
  type thread_subscription = z.Row<
    (typeof schema)["tables"]["thread_subscription"]
  >
}

const schema = z.createSchema({ tables })
